// extracted by mini-css-extract-plugin
export var contentBody = "_dt-9";
export var headerImage = "_dt-2";
export var imageButton = "_dt-7";
export var imageButtonIcon = "_dt-8";
export var imageHeader = "_dt-4";
export var imageHeaderText = "_dt-5";
export var imageOverlay = "_dt-3";
export var imageTitle = "_dt-6";
export var imageWrapper = "_dt-1";
export var taskList = "_dt-a";
export var widget = "_dt-0";